import { useEffect, useMemo, useState } from 'react';
import { fetchList } from './api';

const moeda = (v) => `R$ ${Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const ConstrutorIndicadoresPage = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const load = async () => {
      const data = await fetchList('/api/construtor/orcado-realizado');
      setItems(Array.isArray(data?.items) ? data.items : []);
    };
    load();
  }, []);

  const total = useMemo(() => {
    return items.reduce(
      (acc, item) => {
        acc.orcado += Number(item.valor_orcado || 0);
        acc.realizado += Number(item.valor_realizado || 0);
        acc.variacao += Number(item.variacao || 0);
        return acc;
      },
      { orcado: 0, realizado: 0, variacao: 0 }
    );
  }, [items]);

  return (
    <div className="animate-fade-in space-y-6">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Indicadores</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="card"><div className="card-body"><p className="text-sm text-gray-500">Total Orcado</p><p className="text-2xl font-semibold">{moeda(total.orcado)}</p></div></div>
        <div className="card"><div className="card-body"><p className="text-sm text-gray-500">Total Realizado</p><p className="text-2xl font-semibold">{moeda(total.realizado)}</p></div></div>
        <div className="card"><div className="card-body"><p className="text-sm text-gray-500">Variacao</p><p className="text-2xl font-semibold">{moeda(total.variacao)}</p></div></div>
      </div>

      <div className="card">
        <div className="card-header">Orcado x Realizado por obra</div>
        <div className="card-body p-0">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Obra</th>
                  <th>Orcado</th>
                  <th>Realizado</th>
                  <th>Variacao</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.obra_id}>
                    <td>{it.obra_nome}</td>
                    <td>{moeda(it.valor_orcado)}</td>
                    <td>{moeda(it.valor_realizado)}</td>
                    <td>{moeda(it.variacao)}</td>
                  </tr>
                ))}
                {items.length === 0 && <tr><td colSpan={4} className="text-center text-gray-500 py-6">Sem dados</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConstrutorIndicadoresPage;
